import React, { useEffect, useState } from "react";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
import { message } from "antd";
import { setError } from "./errorSlice";

export const fetchAllPeriods = createAsyncThunk(
  "pageAccess/fetchAllPeriods",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Period`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch periods: ${errorText}`);
      }

      const data = await response.json();
      console.log("Fetched Periods:", data);
      return data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  periods: [],
  loading: false,
  error: null,
};

const pageAccessSlice = createSlice({
  name: "periods",
  initialState,
  reducers: {}, // Defined reducers can be added if needed
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPeriods.fulfilled, (state, action) => {
        //console.log('action.payload',action.payload);
        state.periods = action.payload.sort((a, b) => {
          const getPeriodNumber = (periodName) => {
            // Extract the numeric part of the period name (assuming valid format)
            const matches = periodName.match(/(\d+)/);
            return matches ? parseInt(matches[0], 10) : Infinity; // Return Infinity for non-conforming strings
          };

          const numberA = getPeriodNumber(a.periodName);
          const numberB = getPeriodNumber(b.periodName);

          return numberA - numberB; // This will sort numerically
        });
        state.loading = false;
      })
      .addCase(fetchAllPeriods.pending, (state) => {
        state.loading = true; // Whenever loading starts
      })
      .addCase(fetchAllPeriods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Set error if any
        state.periods = false; // Reset access on error
      });
  },
});

export default pageAccessSlice.reducer;

export function extractPageNames(arr) {
  if (!Array.isArray(arr)) {
    console.error("Input must be an array", arr);
    return [];
  }

  return arr
    .map((item) => {
      if (typeof item === "object" && item !== null && "pageName" in item) {
        return item.pageName;
      }
      return null;
    })
    .filter((name) => name !== null);
}
